import { render, staticRenderFns } from "./ExchangeActionMolecule.vue?vue&type=template&id=6ce4bd6c&"
import script from "./ExchangeActionMolecule.vue?vue&type=script&lang=ts&"
export * from "./ExchangeActionMolecule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports